import { useQuery } from '@tanstack/react-query';
import api from 'constants/api';
import { useSelector } from 'react-redux';
import { authProfile } from 'redux/auth/selectors';
import Api from 'util/Api';
import { StorePageSort, StorePageable } from './StoreService';

export interface MarketplaceLogisticOperator {
  logisticOperatorID: number;
}

export interface Marketplace {
  id: number;
  name: string;
  ownerType: number;
  ownerId: number;
  customerId: number;
  active: boolean;
  published: boolean;
  private: boolean;
  stock: boolean;
  sendCustomerNotifications: boolean;
  detail: string;
  dispatchAddress: string;
  clientCode: string | null;
  contactSupport: string;
  emailSupport: string;
  phoneSupport: string;
  commercialContact: string;
  commercialEmail: string;
  commercialPhone: string;
  commercialAgent: string;
  logisticOperators: MarketplaceLogisticOperator[];
}

export interface MarketplacePage {
  content: Marketplace[];
  pageable: StorePageable;
  sort: StorePageSort;
  first: boolean;
  last: boolean;
  number: number;
  numberOfElements: number;
  size: number;
  totalElements: number;
  totalPages: number;
  empty: boolean;
}

const getMarketplaces = async (
  page = 0,
  size = 10000,
  search = '',
): Promise<Marketplace[]> => {
  const searchParams = new URLSearchParams({
    take: String(size),
    size: String(size),
    page: String(page),
    search,
  });
  const { data } = await Api.apiAxios.get(
    `${api.marketplaces.get}?${searchParams.toString()}`,
  );
  return data.data.content ?? [];
};

export const useMarketplaces = (page = 0, size = 10000, search = '') => {
  const profile = useSelector(authProfile);
  return useQuery({
    queryKey: ['marketplaces', profile?.id, page, size, search],
    queryFn: () => getMarketplaces(page, size, search),
    retry: 1,
    placeholderData: [],
  });
};
